<template>
  <div
    ref="brandSection"
    class="brand-section"
  >

    <div class="brand-section-content">
      <div class="head">
        <div class="title">品牌</div>
        <div class="reminder">{{defaultBrandCateMessage}}</div>
      </div>
      <div class="content">
        <div
          v-for="(item, index) in brandCateList"
          :key="index"
          v-show="index<=1"
          class="periods"
          :class="{active:defaultBrandCate&&everyFilter(defaultBrandCate,item)}"
          @click="onClickDefaultBrandCate(item)"
          :clstag="'jr|keycount|jdjr_search_brand|brand'+item.brandCode"
        >{{item.barndNameFull.length>5?item.barndNameFull.substr(0,5)+"...":item.barndNameFull}}</div>
        <div
          class="periods check-all"
          @click="onClickAllBrandShow"
          v-if="brandCateList.length>2"
        >查看全部</div>

        <div
          class="periods hidden"
          v-if="brandCateList.length==1||brandCateList.length==2"
        ></div>
        <div
          class="periods hidden"
          v-if="brandCateList.length==1"
        ></div>
      </div>
    </div>
    <div class="brand-section-base">

    </div>

  </div>
</template>

<script>
export default {
  name: 'BrandSection',
  components: {},
  data() {
    return {};
  },
  props: {
    brandCateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultBrandCate: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  computed: {
    defaultBrandCateMessage: function() {
      if (this.defaultBrandCate.length == 1) {
        return this.defaultBrandCate[0].barndNameFull;
      } else if (this.defaultBrandCate.length == 2) {
        return this.defaultBrandCate[0].barndNameFull + ',' + this.defaultBrandCate[1].barndNameFull;
      } else if (this.defaultBrandCate.length > 2) {
        return this.defaultBrandCate[0].barndNameFull + ',' + this.defaultBrandCate[1].barndNameFull + '等' + this.defaultBrandCate.length + '种品牌';
      }
    }
  },

  created() {},
  methods: {
    everyFilter(array, items) {
      return array.some(function(item) {
        return item.brandCode == items.brandCode;
      });
    },
    onClickAllBrandShow() {
      this.$emit('onClickAllBrandShow');
    },
    onClickDefaultBrandCate(value) {
      this.$emit('onClickDefaultBrandCate', value);
    }
  },
  mounted() {},
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.brand-section {
  .brand-section-content {
    width: 100%;
    padding: $rem30 0 $rem30 $rem24;
    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-right: $rem24;
      margin-bottom: $rem30;
      .title {
        font-family: PingFangSC-Medium;
        font-size: $rem32;
        line-height: $rem32;
        color: #222222;
        letter-spacing: 0;
        //width: $rem64;
        flex-shrink: 0;
        margin-right: $rem30;
        //margin-bottom: $rem30;
      }
      .reminder {
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #d2a35f;
        letter-spacing: 0;
        line-height: $rem32;
        //margin-bottom: $rem30;
      }
    }
    .price {
      display: flex;
      flex-direction: row;
      justify-content: left;
      align-items: center;
      padding-right: $rem24;
      margin-bottom: $rem26;
      .common {
        background: #f7f7f7;
        border-radius: $rem100;
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #cccccc;
        letter-spacing: 0;
        line-height: $rem24;
        padding: $rem20 0;
        text-align: center;
      }
      .line {
        opacity: 0.55;
        background: #333333;
        width: $rem20;
        height: $rem2;
        margin: 0 $rem21;
      }
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: left;

      .periods {
        margin-right: $rem26;
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        line-height: $rem26;
        background: #f7f7f7;
        border-radius: $rem100;
        padding: $rem19 0;
        border: 1px solid #f7f7f7;
        &.active {
          color: #d2a35f;
          border: 1px solid #d2a35f;
          //opacity: 0.12;
          background: rgba(194, 148, 81, 0.12);
        }
      }
      .check-all {
        border: 1px solid #cccccc;
        background: #ffffff;
      }
      .hidden {
        visibility: hidden;
      }
    }
  }
  .brand-section-base {
    width: 100%;
    background: #f7f7f7;
    height: $rem20;
  }
}
</style>
